import { registerHandler } from "../handler";
import { LibCategories, waitForConsent } from "@utils/consent";

const DE_AFFILIATE_PIXEL_URL =
  "https://d.adup-tech.com/campaign/conversion/7613?t=MjA4MA%3D%3D";

function fireAdupPixel(url: string) {
  const adsWizzPixel = document.createElement("img");

  adsWizzPixel.setAttribute("id", "aduptech-pixel");
  adsWizzPixel.setAttribute("src", url);
  adsWizzPixel.setAttribute("height", "1px");
  adsWizzPixel.setAttribute("width", "1px");
  adsWizzPixel.setAttribute("style", "display:none;");
  adsWizzPixel.setAttribute("border", "0px");
  adsWizzPixel.setAttribute("alt", "");

  document.body.appendChild(adsWizzPixel);
}

export default function registerHandlers() {
  registerHandler("purchase", () => {
    waitForConsent([LibCategories.targetingCookies]).then(() =>
      fireAdupPixel(DE_AFFILIATE_PIXEL_URL)
    );
  });
}
